import { RouteProp, useRoute } from "@react-navigation/native";
import { Button, Card, Divider, Spinner, Text } from "@ui-kitten/components";
import React from "react";
import { View } from "react-native";
import { ScreenLayout } from "../common/layout/ScreenLayout";
import { FlavorStackParamList } from "../navigation";
import { FlavorForm } from "./FlavorForm";
import { useFlavor } from "./useFlavor";

export const FlavorEditScreen = () => {
    const { params } = useRoute<RouteProp<FlavorStackParamList>>();

    const {
        isFormPristine,
        setName,
        setRating,
        setWarning,
        setComment,
        setInMixPercentage,
        setSingleFlavorPercentage,
        isSaving,
        saveAndGoToList,
        isValid,
        name,
        rating,
        warning,
        comment,
        inMixPercentage,
        singleFlavorPercentage,
        manufacturer,
    } = useFlavor(params?.flavorId);

    const handleSave = async () => {
        return isSaving ? null : await saveAndGoToList();
    };

    return (
        <View style={{ flex: 1 }}>
            <ScreenLayout scroll={true}>
                <View>
                    <Text category="h6">{`${manufacturer?.shortname} ${name}`}</Text>
                    <FlavorForm
                        onInMixPercentageChange={setInMixPercentage}
                        onSingleFlavorPercentageChange={setSingleFlavorPercentage}
                        onNameChange={setName}
                        onRatingChange={setRating}
                        onWarningChange={setWarning}
                        onCommentChange={setComment}
                        name={name}
                        rating={rating}
                        warning={warning}
                        comment={comment}
                        inMixPercentage={inMixPercentage}
                        singleFlavorPercentage={singleFlavorPercentage}
                    />
                    <Divider style={{ marginVertical: 16 }} />
                </View>
            </ScreenLayout>
            <View>
                <Card>
                    <Button
                        onPress={async () => handleSave()}
                        disabled={!isValid || isFormPristine}
                        style={{ flex: 0.7, marginRight: 8 }}
                        size="small"
                        accessoryRight={(props) =>
                            isSaving ? <Spinner {...props} size="small" status="control" /> : <></>
                        }
                    >
                        {(props) => <Text {...props}>{!isSaving ? "Save" : "Saving..."}</Text>}
                    </Button>
                </Card>
            </View>
        </View>
    );
};
